import { FileUploadModal } from '@app/components/FileUpload'
import { shareAttachmentActionCreators } from '@app/components/ShareAttachmentModal/modules/shareAttachment'
import { IAttachment } from '@app/models/Attachment'
import { formatDate } from '@app/utils/formatting'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import classNames from 'classnames'
import * as React from 'react'
import { Button } from 'reactstrap'

export interface IAttachmentsListItemProps {
  attachment: IAttachment
  className?: string
  onChange: (e: IAttachment) => void
  propertyId?: string
  style?: React.CSSProperties
}

type AttachmentsListItemProps = IAttachmentsListItemProps &
  typeof shareAttachmentActionCreators

interface IComponentState {
  isOpen: any
}

export class AttachmentsListItem extends React.PureComponent<
  AttachmentsListItemProps,
  IComponentState
> {
  public constructor(props: any) {
    super(props)

    this.state = {
      isOpen: {},
    }
  }

  public render() {
    return (
      <div
        className={classNames(
          'd-flex align-items-center',
          this.props.className,
        )}
        style={this.props.style}
      >
        <div className='p-2 w-50 flex-grow-1'>
          <div
            className='font-weight-bold text-truncate'
            title={this.props.attachment.title}
          >
            <a
              className='text-dark'
              href={`/api/Files/${this.props.attachment.id}/Download`}
              target='_blank'
              rel='noreferrer'
            >
              {this.props.attachment.title}
            </a>
          </div>
          <div className='small text-muted'>
            {formatDate(
              this.props.attachment.dateCreated,
              'MMM D, YYYY hh:mm A',
            )}
            {this.props.attachment.isPublic && (
              <span className='ml-2' title='Visible to public'>
                <FontAwesomeIcon icon={['far', 'lock-open']} fixedWidth />
              </span>
            )}
          </div>
        </div>
        <div>
          <Button
            color='link'
            onClick={() =>
              this.setState({ isOpen: { [this.props.attachment.id]: true } })
            }
            title='Edit'
          >
            <FontAwesomeIcon icon={['fal', 'pen']} fixedWidth />
          </Button>
          <Button
            color='link'
            title='Download'
            href={`/api/Files/${this.props.attachment.id}/Download`}
            target='_blank'
            rel='noreferrer'
          >
            <FontAwesomeIcon icon={['fal', 'download']} fixedWidth />
          </Button>
          <Button
            color='link'
            onClick={() =>
              this.props.showShareAttachmentModal(
                this.props.attachment,
                this.props.propertyId,
              )
            }
            title='Share'
          >
            <FontAwesomeIcon icon={['fal', 'share-alt']} fixedWidth />
          </Button>

          <FileUploadModal
            onCancel={() =>
              this.setState({ isOpen: { [this.props.attachment.id]: false } })
            }
            identifier='attachments-list-item'
            onSave={(e: IAttachment) => {
              this.setState({ isOpen: { [this.props.attachment.id]: false } })
              this.props.onChange(e)
            }}
            attachment={this.props.attachment}
            isOpen={this.state.isOpen[this.props.attachment.id]}
          />
        </div>
      </div>
    )
  }
}
